import request from '@/utils/request'

export type CreateOrderTypeRequest = 'input_fields' | 'csv'

export interface CreateOrderInputFieldsAttributes {
  ursaf_event_id: string
  program_id: string
  type_request: 'input_fields'
  customer_id: string
  amount: string
  scheduled_at: string
  customer_client_reference?: string
}

export interface CreateOrderCsvAttributes {
  ursaf_event_id: string
  program_id: string
  type_request: 'csv'
  blob: string
  scheduled_at: string
}

export type CreateOrderAttributes = CreateOrderInputFieldsAttributes | CreateOrderCsvAttributes

export interface CreateOrderLineResult {
  id: string
  amount_cents: number
  customer_id: string
  scheduled_at?: string
  multi_choice_card_order_id: string
}

export interface CreateOrderFail {
  row_number?: number
  errors?: string[]
  [key: string]: unknown
}

export interface CreateOrderResponseAttributes {
  id: string
  number?: string
  dotation_operation_id?: string
  caretaker_id?: string
  amount_cents?: number
  expire_at?: string | null
  status?: string
  multi_choice_gift_card_id?: string
  confirmed_at?: string | null
  payed_at?: string | null
  program_id?: string
  created_at?: string
  updated_at?: string
  fails?: CreateOrderFail[]
  success?: CreateOrderLineResult[]
}

export interface CreateOrderResponse {
  data: {
    id: string
    type: string
    attributes: CreateOrderResponseAttributes
  }
}

export const createMultiChoiceCardOrder = (attributes: CreateOrderAttributes) =>
  request({
    url: '/market/v1/multi_choice_card_orders',
    method: 'post',
    timeout: 60000,
    data: {
      multi_choice_card_order: attributes
    }
  }) as Promise<CreateOrderResponse>

export const payMultiChoiceCardOrder = (orderId: string) =>
  request({
    url: `/market/v1/multi_choice_card_orders/${orderId}/pay`,
    method: 'put',
    timeout: 60000
  })

// scheduledAt: null sends immediately, a 'YYYY-MM-DD' string applies that date to the order and
// every one of its lines at once
export const rescheduleMultiChoiceCardOrder = (orderId: string, scheduledAt: string | null) =>
  request({
    url: `/market/v1/multi_choice_card_orders/${orderId}/reschedule`,
    method: 'put',
    timeout: 60000,
    data: { scheduled_at: scheduledAt }
  })
